import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'mak_date': {
    title: '开票日期',
    type: 'date',
    equation: all
  },
  'invo_infoid': {
    title: '制票通知单号',
    type: 'input',
    equation: all
  },
  'w_invo_infoid': {
    title: '外部制票通知单号',
    type: 'input',
    equation: all,
    width: 140
  },
  'customer': {
    title: '开票客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '开票客户编号'
    }
  },
  'cust_name': {
    title: '开票客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'zzfld00002j': {
    describe: true,
    title: '客户性质',
    type: 'select',
    equation: cusname,
    dictionary: 'A0004'
  },
  'ycate': {
    describe: true,
    title: '月报分类',
    type: 'select',
    equation: all,
    dictionary: 'A0016',
    width: 180
  },
  'brand': {
    describe: true,
    title: '品牌(生产计划)',
    type: 'select',
    equation: cusname,
    dictionary: 'A0015',
    width: 180
  },
  'description': {
    title: '产品描述',
    type: 'input',
    equation: cusname,
    width: 300
  },
  'degree': {
    title: '度数'
  },
  'norms': {
    title: '显示规格',
    width: 200
  },
  'net_price': {
    title: '开票单价(元/盒)',
    width: 140,
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld000009': {
    title: '订单件数(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ord_price': {
    title: '订单金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'use_zzfld9': {
    title: '已开票件数(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'inv_price': {
    title: '已开票金额(万元)',
    width: 140,
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002k': {
    describe: true,
    title: '发货类型',
    type: 'select',
    equation: cusname,
    dictionary: 'A0005'
  },
  'zzfld00002n': {
    title: '收货地址',
    type: 'input',
    equation: all,
    width: 200
  },
  'zzfld000002': {
    describe: true,
    title: '省区',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'zzfld00002l': {
    title: '收货联系人',
    type: 'input',
    equation: all
  },
  'remark': {
    title: '备注',
    type: 'input',
    equation: all
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/batchTicketReportForms.js